import { CheckCircle2,XCircle } from "lucide-react";

export const SuccessMessage = ({type}) => {
  return (
    <div className="bg-success/10 border border-success rounded-lg p-6 animate-fade-in">
      <div className="flex items-start gap-3">
        <CheckCircle2 className="h-6 w-6 text-success flex-shrink-0 mt-0.5" />
        <div className="space-y-2">
          <h3 className="font-bold text-success text-lg">
            {
              type === "reverify"
                ? "Successfully Re-Verified!!"
                : type === "delink"
                  ? "Successfully Delinked! We will be waiting for your comeback "
                  : "User Onboarding Successful!"
            }
            </h3>
          {/* <p className="text-sm text-foreground">
            Please check your email for next steps. You will receive an activation link to access the Access Point Portal.
          </p>
          <p className="text-xs text-muted-foreground mt-3">
            Once you click the activation link, you'll be able to log in with your username and password.
          </p> */}
        </div>
      </div>
    </div>
  );
};

export const FailureMessage = ({ message }: { message?: string }) => {
  return (
    <div className="bg-destructive/10 border border-destructive rounded-lg p-6 animate-fade-in">
      <div className="flex items-start gap-3">
        <XCircle className="h-6 w-6 text-destructive flex-shrink-0 mt-0.5" />
        <div className="space-y-2">
          <h3 className="font-bold text-destructive text-lg">
            {
              message === "reverify"
                ? "Re-verification was not successful."
                : message === "delink"
                  ? "Delinking was not successful."
                  : "User onboarding was not successful."
            }
          </h3>
          <p className="text-sm text-foreground">
           Something went wrong during {message === "reverify" ? "Re-Verification" : message === "delink" ? "Delinking" : "On boarding"}. Please try again.
          </p>
          <p className="text-xs text-muted-foreground mt-3">
            If the issue persists, contact support for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

